import {cloneDeep, isEqual} from 'lodash';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PreferredCategories} from '../model/portfolio-preferences.model';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
    selector: 'app-portfolio-preferences-picker',
    templateUrl: './portfolio-preferences-picker.component.html',
    styleUrls: ['../../assets/styles/finzy-styles.scss', './portfolio-preferences-picker.component.scss'],
    animations: [
        trigger('fade', [
            state('shown', style({opacity: 1})),
            state('hidden', style({opacity: 0})),
            transition('shown => hidden', [
                animate('300ms 300ms ease-in-out')
            ]),
            transition('hidden => shown', animate('300ms ease-in-out'))
        ])
    ]
})
export class PortfolioPreferencesPickerComponent {
    isExpanded = false;
    changedPreferredCategories: PreferredCategories[];
    originalPreferredCategories: PreferredCategories[];
    @Output()
    public readonly onPreferredCategoriesChanged = new EventEmitter<PreferredCategories[]>();
    @Input()
    enablePositiveButtonOnChange = false;

    _isAlwaysExpanded: boolean;

    @Input()
    public set isAlwaysExpanded(val: boolean) {
        this.isExpanded = val;
        this._isAlwaysExpanded = val;
    }

    @Input()
    set preferredCategories(categories: PreferredCategories[]) {
        this.onPreferredCategoriesReceived(categories);
    }

    public onPreferredCategoriesReceived(categories: PreferredCategories[]) {
        this.originalPreferredCategories = categories;
        this.changedPreferredCategories = cloneDeep(categories);
    }

    public cancel() {
        this.collapse();
        this.changedPreferredCategories = cloneDeep(this.originalPreferredCategories);
    }

    public onFindLoansClicked(changedPreferredCategories: PreferredCategories[]) {
        this.onPreferredCategoriesChanged.emit(changedPreferredCategories);
        this.collapse();
    }

    public expand() {
        this.isExpanded = true;
    }

    public shouldDisablePositiveButton(): boolean {
        if (!this.enablePositiveButtonOnChange) {
            return false;
        } else {
            const newPreferredRatings = new Set(this.changedPreferredCategories.map(p => p.ratingList));
            const originalPreferredRatings = new Set(this.originalPreferredCategories.map(p => p.ratingList));
            return isEqual(originalPreferredRatings, newPreferredRatings);
        }
    }

    private collapse() {
        if (!this._isAlwaysExpanded) {
            this.isExpanded = false;
        }
    }
}